import { useCallback, useState } from 'react';

import { useSetupEmployerMode } from '../../hooks';
import { usePropagateOverridablePropertiesQuery } from '../../queries/usePropagateOverridableProperties.query';
import { useModalType } from '../../stores';

export const useSyncUpdatesFlow = () => {
  const { syncModal, syncModalChanges, setSyncModal, setSuccessfullySavedModal, setSyncModalChanges, setUpdatedOrgsCount } = useModalType();
  const [confirmModal, setConfirmModal] = useState(false);
  const [syncSelectedProperties, setSyncSelectedProperties] = useState<string[]>([]);
  const { employerID, toView } = useSetupEmployerMode();
  const { propagateOverridableProperties } = usePropagateOverridablePropertiesQuery();

  const handleSkipSync = useCallback(() => {
    setSyncSelectedProperties([]);
    setSyncModal(false);
    setConfirmModal(true);
  }, [setSyncModal]);

  const handleSyncSelected = useCallback((selected: string[]) => {
    setSyncSelectedProperties(selected);
    setSyncModal(false);
    setConfirmModal(true);
  }, [setSyncModal]);

  const handleConfirmBack = useCallback(() => {
    setConfirmModal(false);
    setSyncModal(true);
  }, [setSyncModal]);

  const handleConfirmClose = useCallback(() => {
    setSyncModal(false);
    setConfirmModal(false);
    setSyncModalChanges([]);
    setUpdatedOrgsCount(0);
    toView();
    setSuccessfullySavedModal(true);
  }, [setSyncModal, setSyncModalChanges, setUpdatedOrgsCount, toView, setSuccessfullySavedModal]);

  const handleConfirm = useCallback(async () => {
    if (employerID && syncSelectedProperties.length) {
      const properties = syncModalChanges
        .filter((item) => syncSelectedProperties.includes(item.propertyName))
        .map((item) => ({
          property_name: item.propertyName,
          display_name: item.displayName,
          old_value: item.oldValue ?? undefined,
          new_value: item.newValue ?? undefined,
        }));
      const result = await propagateOverridableProperties({ organizationId: employerID, properties });
      setUpdatedOrgsCount(result?.data?.updated_organizations_number ?? 0);
    }
    setConfirmModal(false);
    setSyncModalChanges([]);
    toView();
    setSuccessfullySavedModal(true);
  }, [setSuccessfullySavedModal, setSyncModalChanges, propagateOverridableProperties, setUpdatedOrgsCount, toView, employerID, syncSelectedProperties, syncModalChanges]);

  return {
    syncModal,
    syncModalChanges,
    confirmModal,
    syncSelectedProperties,
    handleSkipSync,
    handleSyncSelected,
    handleConfirmBack,
    handleConfirmClose,
    handleConfirm,
  };
};
